
import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from '../../../sushi'
import { BIGNUMBER_FMT } from '../../../constants/bakery'

const ArtworkLevel = styled.div`
  display: flex;
  margin-bottom: 15px;
  width: 100%;
  height: 17px;
  justify-content: space-between;
`

export function InfoSolt ({artwork, isMyArtwork=true}: {artwork: any, isMyArtwork?: boolean}) {
  const theme = useContext(ThemeContext)
  return (
    <>
      {
        artwork && artwork.attributes ?
        <>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Price：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{artwork.price 
                // eslint-disable-next-line no-useless-concat
                ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' ' + 'Doggy') 
                : '-'} </Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>APY：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>
            {
              artwork.roi && !artwork.roi.isNaN() && artwork.roi.gt(0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
                  ? artwork.roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                  : '-'
            }
            </Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Breed：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{ artwork.attributes.breed }</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Color：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{ artwork.attributes.color }</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Accessory：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{ artwork.attributes.accessoryType }</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Collectible value：</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{ artwork.attributes.collectibleValue }</Text>
          </ArtworkLevel>
        </> : null
      }
    </>
  )
}